import React from 'react';
import { Helmet } from "react-helmet";

class ContactPage extends React.Component {
    render() {
        return (
            <section className="container contact">
                <Helmet>
                    <title>Contact | Ailsa Lyn Artist</title>
                    <meta name="description" content="Contact me by email, phone or facebook." />
                    <meta property="og:title" content="Ailsa Lyn Artist - Contact" />
                    <meta property="og:url" content="https://ailsalyn.co.uk/contact" />
                    <meta property="og:description" content="Contact me by email, phone or facebook." />
                </Helmet>
                <p className="text-center">For commissions or enquiries please contact me using one of the following:</p>

                <div className="row contact-details">
                    <div className="ml-auto mr-auto">
                        <span><i className="fa fa-phone" /><a href="tel:+44 1787 311180">+44 (0) 1787 311180</a></span>
                        <div className="md-100" />
                        <span><i className="fa fa-envelope" /><a href="mailto:ailsalyn@hotmail.co.uk">ailsalyn@hotmail.co.uk</a></span>
                        <div className="md-100" />
                        <span><i className="fa fa-facebook-official" /><a href="https://www.facebook.com/ailsa.lyn.7" target="_blank">Ailsa Lyn</a></span>
                    </div>
                </div>

            </section>
        );
    }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/components/contact/ContactPage.js